import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataListCompleted: [],
  dataListArchiving: [],
  dataDetail: [],
  dataVerifikasi: [],
  keyword: {
    listIssueArchiving: ""
  },
  loading: false,
  sortConfig: {
    key: "id",
    direction: "ASC",
  },
  listCabang: [],
  listKRI: [],
  listHeader: [],
  listHeaderEskalasi: [],
  dataComment: [],
  dataCompleted: [],
  dataHistory: []
};

export const Archiving = createSlice({
  name: "archiving",
  initialState,
  reducers: {
    ChangeData: (state, action) => {
      state.data = action.payload;
    },
    ChangeKeyword: (state, action) => {
      const { menu, value } = action.payload;
      state.keyword[menu] = value;
    },
    ChangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    ChangeSortConfig: (state, action) => {
      state.sortConfig = action.payload;
    },
    ChangeListCabang: (state, action) => {
      state.listCabang = action.payload;
    },
    ChangeListHeader: (state, action) => {
      state.listHeader = action.payload;
    },
    ChangeListHeaderEskalasi: (state, action) => {
      state.listHeaderEskalasi = action.payload;
    },
    ChangeDataComment: (state, action) => {
      state.dataComment = action.payload;
    },
    ChangeDataCompleted: (state, action) => {
      state.dataCompleted = action.payload;
    },
    ChangeDataListCompleted: (state, action) => {
      state.dataListCompleted = action.payload;
    },
    ChangeDataListArchiving: (state, action) => {
      state.dataListArchiving = action.payload;
    },
  },
});

export const {
  ChangeData,
  ChangeDataDetail,
  ChangeDataVerifikasi,
  ChangeKeyword,
  ChangeLoading,
  ChangeSortConfig,
  ChangeListCabang,
  ChangeListKRI,
  ChangeListHeader,
  ChangeListHeaderEskalasi,
  ChangeDataComment,
  ChangeDataCompleted,
  ChangeDataListCompleted,
  ChangeDataHistory,
  ChangeDataListArchiving
} = Archiving.actions;

export default Archiving.reducer;
